import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React from 'react';
import { UserReview } from "./UserReview";
const UserReviews = ({
  reviews,
  mpacBaseUrl,
  user,
  loginHref,
  filterOutDeletedReview,
  filterOutDeletedVendorResponse,
  vendorName,
  vendorLogo
}) => {
  return /*#__PURE__*/React.createElement(React.Fragment, null, reviews.map((review, index) => {
    const vendorDetails = _objectSpread({
      name: vendorName,
      logo: vendorLogo
    }, review.vendor);
    return /*#__PURE__*/React.createElement(UserReview, _extends({
      key: review.id
    }, review, {
      index: index,
      mpacBaseUrl: mpacBaseUrl,
      filterOutDeletedReview: filterOutDeletedReview,
      filterOutDeletedVendorResponse: filterOutDeletedVendorResponse,
      user: user,
      loginHref: loginHref,
      vendorDetails: vendorDetails
    }));
  }));
};
export default UserReviews;